// eslint-disable-next-line import/prefer-default-export
export const redirectToExternalPage = (url: string) => {
  if (window.prerender) {
    // If we're prerendering, we need to tell prerender to redirect to the external page.
    // Otherwise, prerender will return 200 with the target page's content.
    window.prerender.redirectToExternalPage(url);
  } else {
    window.location.href = url;
  }
};
